import React, { FC } from 'react';
import _ from 'lodash';

import { Model as UserModel } from 'models/user/interface';
import { USER_ROLES } from 'constants/index';
import { useResponsive, useTranslation } from 'client/hooks';

import WaveSpeakAnimation from '../../WaveSpeakAnimation';

import css from './SpeakerIcon.module.scss';

type Props = {
  roomId: string;
  userData: UserModel;
  isSpeaking?: boolean;
  isLoggedIn: boolean;
};

const SpeakerIcon: FC<Props> = (props) => {
  const { userData, roomId, isSpeaking = false, isLoggedIn } = props;
  const [isDesktop] = useResponsive('DESKTOP');
  const { translate } = useTranslation('roles');
  const role = React.useMemo(() => {
    const targetRoom = _.find(userData.roomsRoles, { roomId: String(roomId) });

    if (targetRoom) return targetRoom.role;

    return USER_ROLES.HOST;
  }, [userData, roomId]);

  if (role === USER_ROLES.ADMIN) {
    return null;
  }

  return (
    <div className={css.speaker}>
      <div className={css.avatar}>
        <WaveSpeakAnimation className={css.wave} isSpeaking={isSpeaking} />
        <img src={userData.avatarUrl} alt="" style={{ position: 'relative', zIndex: 2 }} />
      </div>
      <div className={css.info}>
        <div className={css.role}>
          {isDesktop !== undefined && <span>{translate(`${role}`)}</span>}
          {isDesktop !== undefined && isLoggedIn && <span className={css.onlineIndicator}></span>}
        </div>
        <div className={css.name}>
          <span>{userData.name}</span>
        </div>
        <div className={css.occupation}>
          <span>{userData.description}</span>
        </div>
      </div>
    </div>
  );
};

export default SpeakerIcon;
